// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__gq8XT","select":"styles_select__qyA35","networkSelect":"styles_networkSelect__amz7E"};